var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('button',{class:_vm.buttonClassObject,on:{"click":_vm.tryUnlockNextInfinityDimension}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }